import type { ExpoOrder, FlowGraph } from '../types';
import EmptyState from '../EmptyState';
import BoardGrid from './BoardGrid';
import ExpoOrderCard from './ExpoOrderCard';

type Props = {
  orders: ExpoOrder[];
  graph: FlowGraph;
  stationNameById: Map<number, string>;
  nowMs: number;
  selectedGroupId: string | null;
  focusedCardId: string | null;
  onOpenDetail: (groupId: string) => void;
};

const ExpoBoard = ({ orders, graph, stationNameById, nowMs, selectedGroupId, focusedCardId, onOpenDetail }: Props) => {
  if (orders.length === 0) return <EmptyState label="Expo" />;

  return (
    <BoardGrid>
      {orders.map((order) => (
        <ExpoOrderCard
          key={order.groupId}
          order={order}
          graph={graph}
          stationNameById={stationNameById}
          nowMs={nowMs}
          selected={order.groupId === selectedGroupId}
          focused={order.groupId === focusedCardId}
          onOpen={() => onOpenDetail(order.groupId)}
        />
      ))}
    </BoardGrid>
  );
};

export default ExpoBoard;
